'use client'

import { ButtonPrimary } from '@fukku/button/Primary'
import { useCookiesBanner } from 'cookies/hooks/useCookiesBanner'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './CookiesButton.module.scss'

export const CookiesButton = (): React.ReactNode => {
	const { t } = useLabels()
	const { showCookiesBanner } = useCookiesBanner()

	return (
		<ButtonPrimary className={styles.button} onClick={showCookiesBanner}>
			{t('privacy.cookieSettings.button')}
		</ButtonPrimary>
	)
}
